import { createSlice } from "@reduxjs/toolkit";
const initialState = {
    localeId: undefined,
    currencyId: undefined,
    beginLogging: undefined,
    context: undefined,
};
const configurationOptionSlice = createSlice({
    name: "configurationOptions",
    initialState,
    reducers: {
        setLocaleId: (state, action) => {
            state.localeId = action.payload;
        },
        setCurrencyId: (state, action) => {
            state.currencyId = action.payload;
        },
        setBeginLogging: (state, action) => {
            state.beginLogging = action.payload;
        },
        setContext: (state, action) => {
            state.context = action.payload;
        },
        setStartOptions: (state, action) => {
            const { localeId, currencyId, beginLogging, context } = action.payload;
            state.localeId = localeId;
            state.currencyId = currencyId;
            state.beginLogging = beginLogging;
            state.context = context;
        },
        setLoadOptions: (state, action) => {
            const { localeId, currencyId, beginLogging, context } = action.payload;
            state.localeId = localeId;
            state.currencyId = currencyId;
            state.beginLogging = beginLogging;
            state.context = context;
        },
        setResumeOptions: (state, action) => {
            const { localeId, currencyId } = action.payload;
            state.localeId = localeId;
            state.currencyId = currencyId;
        },
    },
});
export const configurationOptionsReducer = configurationOptionSlice.reducer;
export const setLocaleId = configurationOptionSlice.actions.setLocaleId;
export const setCurrencyId = configurationOptionSlice.actions.setCurrencyId;
export const setContext = configurationOptionSlice.actions.setContext;
export const setStartOptions = configurationOptionSlice.actions.setStartOptions;
export const setLoadOptions = configurationOptionSlice.actions.setLoadOptions;
export const setResumeOptions = configurationOptionSlice.actions.setResumeOptions;
//# sourceMappingURL=configurationOptionsReducer.js.map